export default "__VITE_ASSET__BRmAkk1s__"